<template>
    <v-dialog v-model="createNewCoverDialog"  max-width="45%" persistent content-class="ma-0 newcoverdialog" >
        <v-card style="background-color:#f9fafc;">
            <v-card-title class="headline">
                <div style="margin-top: 18px;">
                    <a v-on:click='closeModal' class="right"> <span class="icon-close right icon-enabled"></span> </a>
                    <span v-if="!coverToUpdate" class="dialogheader left">{{$t('Cover.RequestCover.NEW_COVER_TITLE')}}</span>
                    <span v-if="coverToUpdate" class="dialogheader left">Update Cover</span>
                </div>
            </v-card-title>
            <v-card-text class="dialogcontent">
              <div class="coverform" v-show="!loading">
                  <v-form ref="newcoverform" v-model="valid"  @keyup.native.enter="valid && validateForm()" onSubmit="return false;" lazy-validation>
                  <div class="dialogblock">
                    <v-layout row>
                        <v-flex xs12>
                            <CompanySelector id="sellerCompanySelector" ref="sellerCompanySelector" :countryFlag="sellerCountryFlag" :selectedCountry="searchCompany.seller.selectedCountry" :companyTitle="sellerTitle" :countries="allowedCountries" @validateForm="validateForm" @selectedCountryChanged="sellerCountryChanged" />
                        </v-flex>
                    </v-layout>
                    <br>
                    <br>
                    <v-layout row>
                      <v-flex xs12>
                            <CompanySelector id="buyerCompanySelector" ref="buyerCompanySelector" :countryFlag="buyerCountryFlag" :selectedCountry="searchCompany.buyer.selectedCountry" :companyTitle="buyerTitle" :countries="allowedCountries" @validateForm="validateForm" @selectedCountryChanged="buyerCountryChanged" />
                        </v-flex>
                    </v-layout>
                    <br>
                    <br>
                    <v-layout row>
                      <v-flex xs12>
                            <CoverInvoiceDetails ref="coverInvoiceInfo" :disableCurrency="disableCurrency" :invoiceTransferredFromCover="invoiceTransferredFromCover" :defaultCurrency="defaultCurrency" :currencies="allowedCurrencies" @successfulInvoiceTransferOnDispose="successfulInvoiceTransferOnDispose" @validateForm="validateForm" />
                        </v-flex>
                    </v-layout>
                  </div>
                  <v-layout row class="newcoveractions">
                    <v-flex xs12 class="footeractionright">
                        <v-btn v-if="!coverToUpdate" :disabled="!btnEnabled"  color="primary" class="fullsize" @click="createQuote">{{$t('Cover.RequestCover.SUBMIT_BTN')}}</v-btn>
                        <v-btn v-if="coverToUpdate" :disabled="!btnEnabled"  color="primary" class="fullsize" @click="updateCover">{{$t('Cover.RequestCover.UPDATE_COVER_BTN')}}</v-btn>
                    </v-flex>
                  </v-layout>
                </v-form>
              </div>
              <div class="coverloading text-xs-center"  v-if="loading">
                <span class="coverprogress">
                  <v-progress-circular :size="100" indeterminate color="primary"></v-progress-circular>
                </span>
              </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
import coverApi from '@/services/CoverApi'
import CompanySelector from '@/components/cover/newcover/company/CompanySelector'
import CoverInvoiceDetails from '@/components/cover/newcover/CoverInvoiceDetails'
import { mapState } from 'vuex'
import { BusinessException } from '@/services/ErrorHandler'

export default {
  props: ['defaultCurrency', 'currencies', 'coverTransferredFromList'],
  data () {
    return {
      sellerTitle: this.$t('Cover.RequestCover.SELLER_SUB_TITLE'),
      buyerTitle: this.$t('Cover.RequestCover.BUYER_SUB_TITLE'),
      btnEnabled: false,
      valid: true,
      loading: false,
      snackbar: {
        show: false,
        color: 'success',
        text: 'The quote was created with success',
        timeout: 6000
      },
      createCoverSuccessText: this.$t('Cover.RequestCover.CREATE_COVER_SUCCESS_DESC'),
      updateCoverSuccessText: this.$t('Cover.RequestCover.UPDATE_COVER_SUCCESS_DESC'),
      createCoverRejectedText: this.$t('Cover.RequestCover.CREATE_COVER_REJECTED_DESC'),
      createCoverFailedText: this.$t('Cover.RequestCover.CREATE_COVER_FAILED_DESC'),
      updateCoverFailedText: this.$t('Cover.RequestCover.UPDATE_COVER_FAILED_DESC'),
      pendingStatus: 'Pending',
      assessingStatus: 'Assessing',
      rejectedStatus: 'Rejected',
      coverToUpdate: null,
      invoiceTransferredFromCover: null,
      disableCurrency: false
    }
  },
  watch: {
    coverTransferredFromList (val) {
      if (val) {
        this.initCoverToUpdate(this.coverTransferredFromList)
        this.$emit('successfulCoverTransferOnDispose')
      }
    }
  },
  methods: {
    closeModal () {
      this.coverToUpdate = null
      this.disableCurrency = false
      this.initValues()
      this.$store.dispatch('cover/setCreateNewCoverDialog', false)
    },
    initCoverToUpdate (cover) {
      this.coverToUpdate = { id: cover.id }
      this.disableCurrency = true
      this.$refs.sellerCompanySelector.showSelectedCompany = true
      this.$refs.sellerCompanySelector.selectedCompany = cover.seller
      this.$refs.buyerCompanySelector.showSelectedCompany = true
      this.$refs.buyerCompanySelector.selectedCompany = cover.buyer
      this.setInvoiceDetails(cover.invoice)
    },
    successfulInvoiceTransferOnDispose () {
      this.invoiceTransferredFromCover = null
    },
    setInvoiceDetails (invoice) {
      this.invoiceTransferredFromCover = {
        invoiceNumber: invoice.Number,
        invoiceValue: invoice.Amount,
        issueDate: invoice.IssuedAt,
        dueDate: invoice.DueAt,
        currency: invoice.Currency
      }
    },
    async updateCover () {
      let isToClosePopup = false
      try {
        this.loading = true
        this.coverToUpdate.invoice = this.$refs.coverInvoiceInfo.getSelectedInfos()
        let response = await coverApi.updateCover(this.coverToUpdate)
        if (response) {
          this.$emit('refreshUpdatedCoverInformationInList', this.coverToUpdate)
          this.setSnackbarValues(true, 'success', this.updateCoverSuccessText)
        } else {
          this.setSnackbarValues(true, 'error', this.updateCoverFailedText)
        }
        this.$store.dispatch('global/setSnackbar', this.snackbar)
        isToClosePopup = true
      } catch (error) {
        if (error && error.response && error.response.status === 422 && error.response.data && error.response.data.errors && Object.keys(error.response.data.errors).length > 0) {
          throw new BusinessException(Object.keys(error.response.data.errors)[0], error.response.data.errors[Object.keys(error.response.data.errors)[0]])
        } else if (error && error.response && error.response.status === 422 && error.response.data && error.response.data.hasOwnProperty('code')) {
          throw new BusinessException(error.response.data.code, error.response.data.message)
        } else {
          isToClosePopup = true
          throw error
        }
      } finally {
        if (isToClosePopup) {
          this.closeModal()
        }
        this.loading = false
      }
    },
    async createQuote () {
      let isValid = this.validateForm()
      if (isValid) {
        let sellerId = this.$refs.sellerCompanySelector.getCompanyId()
        let buyerId = this.$refs.buyerCompanySelector.getCompanyId()
        let invoiceInfos = this.$refs.coverInvoiceInfo.getSelectedInfos()
        let coverOptions = {
          sellerId: sellerId,
          buyerId: buyerId,
          invoiceValue: invoiceInfos.invoiceValue,
          currency: invoiceInfos.currency,
          dueDate: invoiceInfos.dueDate,
          issueDate: invoiceInfos.issueDate,
          invoiceNumber: invoiceInfos.invoiceNumber
        }
        this.loading = true
        let response = await coverApi.createCover(coverOptions)
        let isPending = false
        let isRejected = false
        if (response) {
          isPending = response.status.toUpperCase() === this.pendingStatus.toUpperCase() || response.status.toUpperCase() === this.assessingStatus.toUpperCase()
          isRejected = response.status.toUpperCase() === this.rejectedStatus.toUpperCase()
          if (isPending) {
            this.setSnackbarValues(true, 'success', this.createCoverSuccessText)
          } else {
            this.setSnackbarValues(true, 'error', this.createCoverRejectedText)
          }
        } else {
          this.setSnackbarValues(true, 'error', this.createCoverFailedText)
        }
        this.$emit('refreshContent')
        this.closeModal()
        this.loading = false
        this.$store.dispatch('global/setSnackbar', this.snackbar)

        if (isPending) {
          await this.$store.dispatch('coverquoted/getCoversQuoted', { coverStatusLabels: this.coverStatus })
          this.$router.push({ path: 'quoted' })
          this.$parent.setHeightForSideInfo()
          await this.$parent.showCoverInfoDetail(response.id, false, 'Quoted', false)
          this.$store.dispatch('cover/setExtendedMode', false)
        }
        if (isRejected) {
          this.$router.push({ path: 'archived' })
        }
      }
    },
    validateForm () {
      this.btnEnabled = this.$refs.newcoverform.validate() && this.$refs.sellerCompanySelector.validate() && this.$refs.buyerCompanySelector.validate() && this.$refs.coverInvoiceInfo.validate()
      return this.btnEnabled
    },
    setSnackbarValues (show, color, text) {
      this.snackbar.show = show
      this.snackbar.color = color
      this.snackbar.text = text
    },
    initValues () {
      if (this.$refs.sellerCompanySelector) {
        this.$refs.sellerCompanySelector.setSearchMode()
      }
      if (this.$refs.buyerCompanySelector) {
        this.$refs.buyerCompanySelector.setSearchMode()
      }
      if (this.$refs.coverInvoiceInfo) {
        this.$refs.coverInvoiceInfo.initMode()
      }
      this.btnEnabled = false
    },
    sellerCountryChanged (country) {
      this.searchCompany.seller.selectedCountry = country.code
    },
    buyerCountryChanged (country) {
      this.searchCompany.buyer.selectedCountry = country.code
    }
  },
  components: {
    CompanySelector,
    CoverInvoiceDetails
  },
  computed: {
    ...mapState('cover', ['createNewCoverDialog', 'coverStatus']),
    ...mapState('countries', ['countriesWithFlag', 'currencyFlags']),
    ...mapState('newcover', ['searchCompany']),
    ...mapState('userdetails', ['userInfos']),
    ...mapState('siteconfig', ['config']),
    sellerCountryFlag: function () {
      let result = this.countriesWithFlag.find(f => f.countryCode.toUpperCase() === this.searchCompany.seller.selectedCountry.toUpperCase())
      return result ? result.countryFlag : ''
    },
    buyerCountryFlag: function () {
      let result = this.countriesWithFlag.find(f => f.countryCode.toUpperCase() === this.searchCompany.buyer.selectedCountry.toUpperCase())
      return result ? result.countryFlag : ''
    },
    allowedCountries: function () {
      if (!this.userInfos || !this.countriesWithFlag || !this.userInfos.allowedCountriesForCoverage || !this.config.newCoverAllowedCountries) {
        return []
      }
      let siteConfigAllowedCountries = this.config.newCoverAllowedCountries.toUpperCase().split(',')
      let userAllowedCountries = this.userInfos.allowedCountriesForCoverage ? this.userInfos.allowedCountriesForCoverage.filter(uc => siteConfigAllowedCountries.some(sc => sc.toUpperCase() === uc.toUpperCase())) : []

      // add at least the customer's country
      if (!userAllowedCountries.some(c => c.toUpperCase() === this.userInfos.country.toUpperCase())) {
        userAllowedCountries.push(this.userInfos.country.toUpperCase())
      }

      let countriesWithFlag = this.countriesWithFlag.filter(cf => userAllowedCountries.some(c => c.toUpperCase() === cf.countryCode.toUpperCase()))
      let result = userAllowedCountries.map(c => {
        return {
          code: c,
          flag: countriesWithFlag.find(f => f.countryCode.toUpperCase() === c.toUpperCase()).countryFlag
        }
      })
      return result
    },
    allowedCurrencies: function () {
      let result = this.currencies.filter(cur => this.allowedCountries.some(ctry => cur.countriesCode.includes(ctry.code)))
      if (!result.some(c => c.currency.toUpperCase() === this.defaultCurrency.currency)) {
        result.push(this.defaultCurrency)
      }
      return result
    }
  }
}
</script>
<style scoped>
.v-dialog__content {
    justify-content: flex-end;
    align-items: baseline;
    z-index: 10001 !important;
}
.v-dialog {
    margin: 0px !important;
}
.headline{
    height: 100px;
}
.dialogheader{
    margin-left: 22px;
}
.dialogcontent{
  padding-left: 31px;
  padding-right: 31px;
  padding-top: 8px;
  padding-bottom: 9px;
}
.dialogblock {
  display: inline-grid;
  width: 100%;
}

.newcoveractions {
  margin-top: 46px;
}
.v-card {
  min-height: 100%
}
.coverloading {
  display:block;
   width:100%;
   height: 100%;
   margin-top: 50%;
}
.coverprogress {
   margin: 0 auto;
}
</style>
